import { render, staticRenderFns } from "./TitleColorDuo.vue?vue&type=template&id=3165da3e&"
import script from "./TitleColorDuo.vue?vue&type=script&lang=js&"
export * from "./TitleColorDuo.vue?vue&type=script&lang=js&"
import style0 from "./TitleColorDuo.vue?vue&type=style&index=0&id=3165da3e&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports